import { Chip as MuiChip, type ChipProps } from '@mui/material';

/**
 * Dashboard-specific chip component with custom styling for success variant
 * Applies dashboard design patterns while maintaining full MUI Chip API compatibility
 */
export const Chip: React.FC<ChipProps> = props => {
  const { color = 'success', size, sx, ...rest } = props;
  const resolvedSize: ChipProps['size'] = size ?? 'small';

  // Apply custom styles only for success color
  const successStyles = {
    border: '1px solid #A4EDC5',
    background: '#E5FFF1',
    color: '#3C3C3C',
  };

  const customStyles: ChipProps['sx'] =
    color === 'success'
      ? ([successStyles, ...(Array.isArray(sx) ? sx : sx ? [sx] : [])] as ChipProps['sx'])
      : sx;

  return <MuiChip color={color} size={resolvedSize} sx={customStyles} {...rest} />;
};
